/* eslint-disable jsx-a11y/alt-text */
import '../../Style/App.css';

import React, { useState } from 'react';

import imgClose from '../../../Resources/Images/close.svg';

import './OrderView.css';
import { POSOrderManager } from '../../Services/POSOrderManager';
import { useAppSelector } from '../../../Redux/Store/hooks';

type LoginViewParameters = {
  email : string,
  channelName : string,
  catalogKey : string,
  backendUrl : string,
  showLogin : (isShowLoginViewActive: boolean) => void,
  authenticator : (sessionToken: string) => void,
};

export function LoginView({
  email, channelName, catalogKey, backendUrl, showLogin, authenticator,
} : LoginViewParameters) {

  const [isChangePassInDisplay, setIsChangePassInDisplay] = useState<boolean>(false);

  const [messageColor, setMessageColor] = useState<string>('#000000');
  const [message, setMessage] = useState<string>('');

  const [password, setPassword] = useState<string>('');

  const [oldPassword, setOldPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordCopy, setNewPasswordCopy] = useState<string>('');

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  const loginView = () => {
    return (
      <div className="login-view">
        <button type="button" className="btn" style={{ float: 'right' }} onClick={() => { showLogin(false); }}>
          <img src={imgClose} alt="User Icon" style={{ width: '15px', height: '15px' }} />
        </button>
        <form className="px-4 py-4">
          <div className="form-group">
            <div>{strings.LOGIN_USERNAME}</div>
            <input type="email" className="form-control" id="FormEmail1" placeholder="email@example.com" value={email} readOnly={true} />
          </div>
          <div className="form-group">
            <div>{strings.LOGIN_PASSWORD}</div>
            <input type="password" className="form-control" id="FormPassword1" value={password} onChange={(e) => { setPassword(e.target.value); }} />
          </div>
          <div style={{ height: '40px', fontSize: '12px', color: messageColor }}>{message}</div>
          <div className="form-group" style={{ paddingBottom: '5px' }}>
            <button
              type="button"
              className="btn btn-light"
              onClick={async () => {
                const result = await POSOrderManager.resetPassword(email, channelName, backendUrl);
                if (result) {
                  setMessageColor('#000000');
                  setMessage(strings.RECOVER_PASSWORD_MESSAGE);
                } else {
                  setMessageColor('#ff0000');
                  setMessage(strings.LOGIN_UNKNOWN_ERROR);
                }
              }}
            >
              {strings.LOGIN_RECOVER_PASSWORD}
            </button>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col" style={{ padding: '0px' }}>
                <button
                  type="button"
                  className="btn btn-light shadow-none"
                  onClick={() => {
                    setMessageColor('#000000');
                    setMessage('');
                    setIsChangePassInDisplay(true);
                  }}
                >
                  {strings.LOGIN_CHANGE_PASSWORD}
                </button>
              </div>
              <div className="col-12 col-sm-auto" style={{ padding: '0px' }}>
                <button
                  type="button"
                  className="btn btn-secondary mr-1"
                  onClick={async () => {
                    // eslint-disable-next-line max-len
                    const result = await POSOrderManager.authenticate(email, password, channelName, catalogKey, backendUrl);
                    authenticator(result);
                    if (result) {
                      setMessageColor('#000000');
                      setMessage(strings.LOGIN_SUCCESSFUL);
                      showLogin(false);
                    } else {
                      setMessageColor('#ff0000');
                      setMessage(strings.LOGIN_CREDENTIALS_NOT_VALID);
                    }
                  }}
                >
                  {strings.LOGIN_ACTION_LOGIN}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };

  const changePasswordView = () => {
    return (
      <div className="change-password-view">
        <button type="button" className="btn" style={{ float: 'right' }} onClick={() => { showLogin(false); }}>
          <img src={imgClose} alt="User Icon" style={{ width: '15px', height: '15px' }} />
        </button>
        <form className="px-4 py-4">
          <div className="form-group">
            <div>{strings.LOGIN_OLD_PASSWORD}</div>
            <input type="password" className="form-control" id="FormPassword2" onChange={(e) => { setOldPassword(e.target.value); }} value={oldPassword} />
          </div>
          <div className="form-group">
            <div>{strings.LOGIN_NEW_PASSWORD}</div>
            <input type="password" className="form-control" id="FormPassword3" onChange={(e) => { setNewPassword(e.target.value); }} value={newPassword} />
          </div>
          <div className="form-group">
            <div>{strings.LOGIN_NEW_PASSWORD_REPEAT}</div>
            <input type="password" className="form-control" id="FormPassword4" onChange={(e) => { setNewPasswordCopy(e.target.value); }} value={newPasswordCopy} />
          </div>
          <div style={{ height: '35px', fontSize: '12px', color: messageColor }}>{message}</div>
          <div className="container-fluid">
            <div className="row">
              <div className="col" style={{ padding: '0px' }}>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setMessageColor('#000000');
                    setMessage('');
                    setIsChangePassInDisplay(false);
                  }}
                >
                  {strings.GO_BACK_ACTION}
                </button>
              </div>
              <div className="col-12 col-sm-auto" style={{ padding: '0px' }}>
                <button
                  type="button"
                  className="btn btn-secondary mr-1"
                  onClick={async () => {
                    // eslint-disable-next-line max-len
                    if (newPassword !== newPasswordCopy) {
                      setMessageColor('#ff0000');
                      setMessage(strings.CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE);
                      return;
                    }

                    // eslint-disable-next-line max-len
                    const result = await POSOrderManager.changePassword(email, channelName, oldPassword, newPassword, newPasswordCopy, backendUrl);
                    if (result) {
                      setMessageColor('#000000');
                      setMessage(strings.CHANGE_PASSWORD_SUCCESSFUL_MESSAGE);
                    } else {
                      setMessageColor('#ff0000');
                      setMessage(strings.CHANGE_PASSWORD_ERROR_MESSAGE);
                    }
                  }}
                >
                  {strings.CONFIRM_ACTION}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };

  return (
    <div>
      { isChangePassInDisplay ? changePasswordView() : loginView() }
    </div>
  );
}
